import * as React from "react";
import { Text, useLocalVariant } from "@draftkings/arena-web";
export const HelperMessage = React.memo(function HelperMessage({ helperMessage, playerBonusId }) {
    const helperMessageVariant = useLocalVariant("text", {
        root: {
            backgroundColor: "#2A751A33",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            borderRadius: "4px",
            border: "1px solid rgba(42, 117, 26, 0.20)",
            padding: "8px 16px",
            gap: "4px",
            marginBottom: "15px"
        }
    });
    return (React.createElement(React.Fragment, null, helperMessage && React.createElement(Text, { testId: `qualifying-bet-bonus-disclaimer-${playerBonusId}`, variant: helperMessageVariant }, helperMessage)));
});
//# sourceMappingURL=HelperMessage.js.map